import React from "react";

export const CarzelleLogo = ({width, height, withText = true}) => {
    return (
        <>
            {withText && <img src="/images/logo.png" className="m-auto animate-fadeIn" alt='Carzelle logo' style={{width: width + 'px', height: height + 'px'}}/>}
            {!withText && <img src="/images/logowithouttext.png" className="m-auto animate-fadeIn" alt='Carzelle logo' style={{width: width + 'px', height: height + 'px'}}/>}
        </>
    )
}